import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'
import i18n from './i18n'

// Import Font Awesome CSS
import '@fortawesome/fontawesome-free/css/all.css'

// Import Tabulator and noUiSlider CSS
import 'nouislider/dist/nouislider.css'
import 'tabulator-tables/dist/css/tabulator.min.css'

// Import global styles
import './styles/application.scss'

// Create Vue application
const app = createApp(App)

// Install plugins
app.use(createPinia())
app.use(i18n)

// Initialize auth store before router setup
const authStore = useAuthStore()

app.use(router)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
        retry: 2,
        refetchOnWindowFocus: false,
      },
    },
  },
})

// Initialize auth early (non-blocking)
authStore.initializeAuth()

// Mount the app
app.mount('#vue-app')

// Export app for potential debugging
export default app
